import React, {useState, useEffect} from 'react';
import {Container, Grid, Typography, List, ListItem, ListItemIcon, ListItemText, Divider, } from '@material-ui/core/';
import { useStyles } from "./style";
import Title from 'components/TitleWithIcon';
import {Lock, Done} from '@material-ui/icons/';

function PoliticasCambioContraseña(props) {
    const classes = useStyles();
    const [politicasContraseña, setPoliticasContraseña] = useState([
        {texto:'Minimo 6 caracteres.'},
        {texto:'Máximo 20 caracteres.'},
        {texto:'Al menos una letra mayúscula.'},
        {texto:'Al menos un caracter especial $@#!¡:;{}+=^~|%*¿?&/-'},
        {texto:'Al menos un número.'},
        {texto:'No espacios en blanco.'},
        // texto:'',
    ])

    return (
        <div >
            <Title title="Cambiar contraseña" icon={"/assets/cambiarContraseña.png"}/>
            <Grid  >
                <div className={classes.colorComponente} >
                    <Grid item xs={12} container direction="row" justify="justify" alignItems="center" className={classes.espacio}> 
                        <Typography component="span" variant="body2" color="textPrimary">Elige una contraseña segura y no la utilices en otras cuentas.</Typography><br/><br/>
                    </Grid>
                    <Grid item xs={12} container direction="row" justify="justify" alignItems="center" className={classes.espacio}> 
                        <Typography component="span" variant="body2" color="textPrimary"> <strong>Política de Seguridad</strong></Typography><br/><br/>
                    </Grid>
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center">
                        <Typography className={classes.espacio} component="span" variant="body2" color="textPrimary">
                            No uses una contraseña de otro sitio ni un nombre demasiado obvio, como el de tu mastoca, su nombre o fecha de nacimiento.
                            <div className={classes.root}>
                                <List component="nav" aria-label="main mailbox folders">
                                    {politicasContraseña.map((data) => (
                                        <ListItem button>
                                            <ListItemIcon>
                                                <Done />
                                            </ListItemIcon>
                                            <ListItemText primary={data.texto}/>
                                        </ListItem>
                                    ))}
                                </List>
                                <Divider />        
                            </div>                    
                        </Typography><br/><br/>
                    </Grid>
                </div>
            </Grid><br/>
        </div>
    );
}


export default PoliticasCambioContraseña;